import React, { useState } from "react";

const MultiSelect = ({ options, defaultSelected, handleServiceChange }) => {
  const [isExpand, setIsExpand] = useState(false);
  const [selected, setSelected] = useState(
    defaultSelected.filter(Boolean) || []
  );
  const [selectOptions, setSelectOptions] = useState(options);

  const getSelectedClass = (selectedData) => {
    let myClass = "hover:border-gold2";
    if (!!selected?.find((item) => item?.id === selectedData?.id)) {
      myClass = "border-[#FAAD14]";
    }
    return myClass;
  };

  const handleSearch = (e) => {
    const query = e?.target?.value;
    const data = options?.filter(({ serviceName }) =>
      serviceName.includes(query || "")
    );
    setSelectOptions(data);
  };
  return (
    <div
      class={`w-full flex flex-col items-center mx-auto ${isExpand && "h-64"}`}
    >
      <div class="w-full">
        <div class="flex flex-col items-center relative">
          <div class="w-full  svelte-1l8159u">
            <div class="my-2 p-1 flex border border-gray-200 bg-white rounded svelte-1l8159u">
              <div class="flex flex-auto flex-wrap">
                {selected?.map((item) => (
                  <div
                    class="flex justify-center items-center m-1 font-medium py-1 px-2 rounded-full text-black bg-gold2 border border-[#FAAD14] "
                    key={item?.id}
                  >
                    <div class="text-xs font-normal leading-none max-w-full flex-initial">
                      {item?.serviceName}
                    </div>
                    <div class="flex flex-auto flex-row-reverse">
                      <div
                        onClick={() => {
                          setSelected(
                            selected?.filter(({ id }) => id !== item?.id)
                          );
                          handleServiceChange(
                            selected
                              ?.filter(({ id }) => id !== item?.id)
                              .map((item) => item?.serviceName)
                              .join(",")
                          );
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="100%"
                          height="100%"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-x cursor-pointer hover:text-[#FAAD14] rounded-full w-4 h-4 ml-2"
                        >
                          <line x1="18" y1="6" x2="6" y2="18"></line>
                          <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                      </div>
                    </div>
                  </div>
                ))}
                <div class="flex-1">
                  <input
                    placeholder=""
                    class="bg-transparent p-1 px-2 appearance-none outline-none h-full w-full text-gray-800"
                    onFocus={() => setIsExpand(true)}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <div
                class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200 svelte-1l8159u"
                onClick={() => setIsExpand(!isExpand)}
              >
                <span class="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none flex justify-center items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100%"
                    height="100%"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class={`feather feather-chevron-up w-4 h-4 ${
                      isExpand && "rotate-180"
                    }`}
                  >
                    <polyline points="18 15 12 9 6 15"></polyline>
                  </svg>
                </span>
              </div>
            </div>
          </div>
          {isExpand && (
            <div class="absolute shadow top-full bg-white z-40 w-full lef-0 rounded overflow-y-auto svelte-5uyqqj">
              <div class="flex flex-col w-full">
                {selectOptions?.map((item) => (
                  <div
                    class="cursor-pointer w-full border-gray-100 rounded-t border-b hover:bg-gold2"
                    key={item?.id}
                    onClick={() => {
                      const exist = selected?.find(({ id }) => id === item?.id);
                      if (!exist) {
                        setSelected([...selected, item]);
                        handleServiceChange(
                          [...selected, item]
                            .map((item) => item?.serviceName)
                            .join(",")
                        );
                      }
                    }}
                  >
                    <div
                      class={
                        "flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative " +
                        getSelectedClass(item)
                      }
                    >
                      <div class="w-full items-center flex">
                        <div class="mx-2 leading-6">{item?.serviceName}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MultiSelect;
